import React, { useState } from "react";
import { Info, Trash2, PlusCircle, } from "feather-icons-react/build/IconComponents";
import apiHandler from "../../../feature-module/common/api";
import { useSelector } from "react-redux";

const ServiceMenuModal = ({
    isOpen,
    setIsOpen,
    businessId,
    callBack
}) => {
    const [dataset, setdata] = useState([{ categoryName: "", ID: 0 }])
    const userData = useSelector((state) => state.user_data);

    const handleAddMore = () => {
        setdata([...dataset, { categoryName: "", ID: 0 }]);
    }

    const handleDelete = (index) => {
        const newDataset = [...dataset];
        newDataset.splice(index, 1);
        setdata(newDataset);
    };

    const handleChange = (e, index) => {
        console.log(e.target.value, "Vakjdhdh");
        const { name, value } = e.target;
        setdata((prev) => prev.map((item, i) => i === index ? { ...item, [name]: value, ID: 0 } : item));
    };

    const HandleServiceMenuSubmit = async (e) => {
        e.preventDefault();

        const response = await apiHandler({
            method: "POST",
            route: "Business/CategoryUpsert",
            payload: {
                loginUser: userData?.id,
                businessId: businessId, categoryList: dataset
            },
        });


        if (response?.ResponseCode === 'SUCCESS') {
            callBack();
            setIsOpen(false);
        }

    };
    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div className="modal-backdrop fade show" />
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
                aria-modal="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        {/* Header */}
                        <div className="modal-header">
                            <h5 className="modal-title">Create Service Menu</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setIsOpen(false)}
                            />
                        </div>

                        {/* Body */}
                        <div className="modal-body">
                            <form onSubmit={HandleServiceMenuSubmit}>
                                <div className="card">
                                    <div className="card-body pb-0">
                                        <div className="accordion" id="serviceMenuAccordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#serviceMenuCollapse"
                                                    >
                                                        <Info className="me-2" />
                                                        Service Menu
                                                    </button>
                                                </h2>

                                                <div
                                                    id="serviceMenuCollapse"
                                                    className="accordion-collapse collapse show"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="row">

                                                            <div className="col-lg-8 col-12">
                                                                {dataset.map((item, index) => (
                                                                    <div key={index} className="mb-3">
                                                                        <label className="form-label">
                                                                            Category Name
                                                                        </label>
                                                                        <div className="d-flex gap-2">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="categoryName"
                                                                                value={item.categoryName}
                                                                                onChange={(e) =>
                                                                                    handleChange(e, index)
                                                                                }
                                                                                required
                                                                            />
                                                                            {dataset.length > 1 && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger d-flex align-items-center justify-content-center px-3"
                                                                                    onClick={() => handleDelete(index)}
                                                                                    title="Delete Category"
                                                                                >
                                                                                    <Trash2 size={18} />
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            <div className="col-lg-4 col-12 mt-4">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary w-100"
                                                                    onClick={handleAddMore}
                                                                >
                                                                  <PlusCircle className="me-2 iconsize" />  Add Category
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={() => setIsOpen(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Save Service Menu
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServiceMenuModal;